import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  IconButton,
  InputBase,
  Avatar,
  Badge,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { ThemeContext } from "./ThemeContext";
import { DashboardLayoutContext } from "../../Routes/DashboardLayoutContext";
import NotificationDropdown from "./Notifications/NotificationDropdown";
import MessageDropdown from "./Messages/MessageDropdown";
import API from "../Authentification/apiAdmin";
import { toast } from "react-toastify";
import "../../Styles/AdminDashbord/topbar.css";

// Fréquence de rafraîchissement du badge (pas de websocket sur hébergement mutualisé)
const POLL_INTERVAL_MS = 30000;

const Topbar = () => {
  const { theme, toggleThemeMode } = useContext(ThemeContext);
  const { sidebarOpen, setSidebarOpen } = useContext(DashboardLayoutContext);
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [openMessages, setOpenMessages] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const unreadMessages = messages.filter((m) => !m.read).length;

  const fetchUnreadCount = () => {
    API.get("/admin/notifications/unread-count")
      .then((res) => setUnreadCount(res.data.count))
      .catch(() => { });
  };

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const handleToggleNotifications = () => {
    const willOpen = !openNotifications;
    setOpenNotifications(willOpen);
    setOpenMessages(false);

    if (willOpen) {
      // Charger la liste à l'ouverture
      API.get("/admin/notifications")
        .then((res) => setNotifications(res.data))
        .catch(() => toast.error("Impossible de charger les notifications"));

      // Marquer tout comme lu et remettre le badge à zéro immédiatement
      setUnreadCount(0);
      API.post("/admin/notifications/mark-all-read").catch(() => { });
    }
  };

  const handleNotifClick = (notif) => {
    setOpenNotifications(false);

    if (notif.type === "order" && notif.related_id) {
      navigate("/admin/commandes", {
        state: { highlightOrderId: notif.related_id },
      });
    } else if (notif.type === "refund" && notif.related_id) {
      navigate("/admin/commandes", {
        state: { highlightOrderId: notif.related_id },
      });
    }
  };

  const logout = async () => {
    try {
      await API.post("/admin/logout");
      localStorage.removeItem("adminToken");
      toast.success("Déconnexion réussie");
      navigate("/admin/");
    } catch {
      toast.error("Erreur lors de la déconnexion");
    }
  };

  return (
    <>
      <header className={`topbar ${theme === "dark" ? "topbar-dark" : "topbar-light"}`}>

        {/* GAUCHE */}
        <div className="topbar-left">
          <IconButton
            className="topbar-hamburger"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>

          <div className="search-box search-box-desktop">
            <InputBase placeholder="Rechercher…" />
            <IconButton>
              <SearchIcon />
            </IconButton>
          </div>
        </div>

        {/* DROITE */}
        <div className="topbar-right">
          <IconButton
            className="topbar-search-icon"
            onClick={() => setSearchOpen(!searchOpen)}
          >
            <SearchIcon />
          </IconButton>

          <IconButton onClick={toggleThemeMode}>
            {theme === "dark" ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
          </IconButton>

          {/* Notifications */}
          <IconButton onClick={handleToggleNotifications}>
            <Badge badgeContent={unreadCount} color="error">
              <NotificationsNoneIcon />
            </Badge>
          </IconButton>
          {openNotifications && (
            <NotificationDropdown
              notifications={notifications}
              onClose={() => setOpenNotifications(false)}
              onItemClick={handleNotifClick}
              onLoadMore={() => {
                // à brancher sur une pagination plus tard si besoin
              }}
            />
          )}

          {/* Messages */}
          <IconButton onClick={() => { setOpenMessages(!openMessages); setOpenNotifications(false); }}>
            <Badge badgeContent={unreadMessages} color="error">
              <MailOutlineIcon />
            </Badge>
          </IconButton>
          {openMessages && (
            <MessageDropdown
              messages={messages}
              onClose={() => setOpenMessages(false)}
            />
          )}

          {/* Avatar */}
          <div className="dropdown">
            <IconButton data-bs-toggle="dropdown">
              <Avatar />
            </IconButton>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <Link className="dropdown-item" to="/admin/paramètres">
                  Paramètres
                </Link>
              </li>
              <li>
                <button className="dropdown-item text-danger" onClick={logout}>
                  Déconnexion
                </button>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {searchOpen && (
        <div className={`topbar-search-mobile ${theme === "dark" ? "topbar-dark" : "topbar-light"}`}>
          <div className="search-box w-100">
            <InputBase placeholder="Rechercher…" fullWidth autoFocus />
            <IconButton>
              <SearchIcon />
            </IconButton>
          </div>
        </div>
      )}
    </>
  );
};

export default Topbar;
